import React from 'react';

const ConfigPanelFooter = ({ children, className }) => (
    <div className={`flex column-footer padding-default border-top config-footer ${className ?? ''}`}>
        {children}
    </div>
);

export default ConfigPanelFooter;
